import { render } from "./CommentsSection.vue?vue&type=template&id=4e9d0340"
import script from "./CommentsSection.vue?vue&type=script&lang=js"
export * from "./CommentsSection.vue?vue&type=script&lang=js"

import "./CommentsSection.vue?vue&type=style&index=0&id=4e9d0340&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__